// reducers/wishListReducer.js

export const initialWishListState = {
    activeTab: 'package',
    //Wishlist ages
    packges: [],
    summaryPack: {},
    pageIndexPack: 1,
    loadingPack: true,
    errorPack: '',

    //Wishlist Shared Safari
    sharedSafaries: [],
    summarySafari: {},
    pageIndexSafari: 1,
    loadingSafari: true,
    errorSafari: '',


};

export const wishListReducer = (state = initialWishListState, action) => {
    switch (action.type) {
         case 'SET_PROFILE_ACTIVE_TAB':
      return {
        ...state,
        activeTab:
          typeof action.payload === 'string' && action.payload.trim().length > 0
            ? action.payload
            : "",
      };
        //shared sfari Listing
        case 'SET_WISHLIST_PACKAGE_DATA':
            return {
                ...state,
                packges: Array.isArray(action.payload)
                    ? action.payload
                    : state.packges,
            };
        case 'APPEND_WISHLIST_PACKAGE_DATA':
            return {
                ...state,
                packges: [
                    ...state.packges,
                    ...action.payload.filter(
                        newItem => !state.packges.some(existing => existing.id === newItem.id)
                    ),
                ],
            };
        case 'SET_WISHLIST_PACKAGE_SUMMARY':
            return {
                ...state,
                summaryPack: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summaryPack,
            };
        case 'SET_WISHLIST_PACKAGE_LOADING':
            return {
                ...state,
                loadingPack:
                    typeof action.payload === 'boolean'
                        ? action.payload
                        : state.loadingPack,
            };
        case 'SET_WISHLIST_PACKAGE_ERROR':
            return {
                ...state,
                errorPack:
                    typeof action.payload === 'string'
                        ? action.payload
                        : state.errorPack,
            };
        case 'SET_WISHLIST_PACKAGE_PAGE_INDEX':
            return {
                ...state,
                pageIndexPack: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndexPack,
            };
        //shared sfari Listing
        case 'SET_WISHLIST_SHARED_SAFARI_DATA':
            return {
                ...state,
                sharedSafaries: Array.isArray(action.payload)
                    ? action.payload
                    : state.sharedSafaries,
            };
        case 'APPEND_WISHLIST_SHARED_SAFARI_DATA':
            return {
                ...state,
                sharedSafaries: [
                    ...state.sharedSafaries,
                    ...action.payload.filter(
                        newItem => !state.sharedSafaries.some(existing => existing.id === newItem.id)
                    ),
                ],
            };
        case 'SHARED_WISHLIST_SHARED_SAFARI_SUMMARY':
            return {
                ...state,
                summarySafari: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summarySafari,
            };
        case 'SET_WISHLIST_SF_DATA_LOADING':
            return {
                ...state,
                loadingSafari:
                    typeof action.payload === 'boolean'
                        ? action.payload
                        : state.loadingSafari,
            };
        case 'SET_WISHLIST_SF_DATA_ERROR':
            return {
                ...state,
                errorSafari:
                    typeof action.payload === 'string'
                        ? action.payload
                        : state.errorSafari,
            };
        case 'SET_WISHLIST_SHARED_SAFARI_PAGE_INDEX':
            return {
                ...state,
                errorSafari: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.errorSafari,
            };


        default:
            return state;
    }
};
